import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import { get, find } from "lodash";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import * as action from "~/store/resource/resourceAction";
import { withTitle } from "~/components/common/molecules/TitleHelmet";

import { partnerInfo } from "~/configs/partnerDetails";
const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const IntroducePageMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "mobile" */ "~/components/desktop/pages/Introduce"
    ),
  loading: LoadableLoading
});
const IntroducePageDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "desktop" */ "~/components/desktop/pages/Introduce"
    ),
  loading: LoadableLoading
});

class Introduce extends Component {
  constructor(props) {
    super(props);
    this.props.getIntroduction();
  }

  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <IntroducePageMobile {...this.props} />
        ) : (
          <IntroducePageDesktop {...this.props} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    resource: { loading, data, error }
  } = state;
  return {
    device: type,
    loading,
    data,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getIntroduction: () => dispatch(action.getIntroduction())
  };
};

const IntroduceHelmet = withTitle({
  component: Introduce,
  title: `${hospitalName.value} | Giới thiệu`
});

export default connect(mapStateToProps, mapDispatchToProps)(IntroduceHelmet);
